import { render, staticRenderFns } from "./addPort.vue?vue&type=template&id=59e4712c&scoped=true"
import script from "./addPort.vue?vue&type=script&lang=js"
export * from "./addPort.vue?vue&type=script&lang=js"
import style0 from "./addPort.vue?vue&type=style&index=0&id=59e4712c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e4712c",
  null
  
)

export default component.exports